<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
// import { db } from "@/db"
// import { mapGetters } from "vuex"
import Empty from "@/layouts/empty"
import Default from "@/layouts/default"

/**
 * Define the main app.
 */
export default {
  // hook external components
  components: {
    Empty,
    Default
  },

  // calculated properties
  computed: {
    // // spread getters
    // ...mapGetters({
    //   userData: "auth/getUser"
    // }),

    // /**
    //  * User ref
    //  */
    // userRef() {
    //   return db.doc(this.userData.userPath)
    // },

    /**
     * Select the relevant component
     * for the app according to the router
     * meta data.
     */
    layout() {
      return this.$route.meta.layout || "default"
    }

    // /**
    //  * Bind user data JWT
    //  */
    // userDataJWT() {
    //   return this.userData.jwt
    // },

    // /**
    //  * Returns the route data
    //  */
    // route() {
    //   return this.$route || {}
    // },
  }

  // // watch props
  // watch: {
  //   userDataJWT: {
  //     immediate: true,
  //     handler() {
  //       if (this.userData.jwt) {
  //         this.bindData()
  //       }
  //     }
  //   }
  // },

  // // component functions
  // methods: {
  //   /**
  //    * Bind data
  //    */
  //   bindData() {
  //     this.$store.dispatch("users/bindDocUsers", this.userData.id)
  //   }
  // },

  // /**
  //  * Unbind users data
  //  */
  // beforeDestroy() {
  //   this.$store.dispatch("users/unbindUsers")
  // }
}
</script>

<style lang="scss">
@import "./style/_main.scss";

* {
  margin: 0;
  padding: 0;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

html {
  font-family: "Raleway", sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  background-color: #eeefef;
}

body {
  filter: blur(0) !important;
  min-height: 100vh;
}
</style>
